import {gql} from '@apollo/client'
import * as Apollo from '@apollo/client'
import {
    ApplyCouponToCartDocument,
    ApplyCouponToCartMutation,
    ApplyCouponToCartMutationVariables
} from '../../generated/graphql'

const defaultOptions = {} as const

export function useApplyCouponToCartMutation(baseOptions?: Apollo.MutationHookOptions<ApplyCouponToCartMutation, ApplyCouponToCartMutationVariables>) {
    const options = {...defaultOptions, ...baseOptions}
    return Apollo.useMutation<ApplyCouponToCartMutation, ApplyCouponToCartMutationVariables>(APPLY_COUPON_TO_CART, options)
}

export const APPLY_COUPON_TO_CART = gql`
    mutation ApplyCouponToCart($cart_id: String!, $coupon_code: String!) {
        applyCouponToCart(input: { cart_id: $cart_id, coupon_code: $coupon_code }) {
            cart {
                email
                applied_coupons {
                    code
                }
                prices {
                    subtotal_including_tax {
                        value
                        currency
                    }
                    subtotal_excluding_tax {
                        value
                        currency
                    }
                    subtotal_with_discount_excluding_tax {
                        value
                        currency
                    }
                    discounts {
                        label
                        amount {
                            value
                            currency
                        }
                    }
                }
                items {
                    uid
                    id
                    quantity
                    product {
                        id
                        uid
                        sku
                        name
                        brand
                        categories {
                            name
                            uid
                        }
                        main_category {
                            name
                        }
                        alfabet_swatch
                        kolor3_swatch
                        cyfry_swatch
                        kolor_emalii_swatch
                        kolor_kamienia_swatch
                        material_swatch
                        rodzaj_kamienia_swatch
                        rozmiar_swatch
                        znaki_zodiaku_swatch
                        url_key
                        description {
                            html
                        }
                        salable_qty
                        sku
                        crosssell_products {
                            sku
                            id
                            salable_qty
                            url_key
                            name
                            uid
                            image {
                                url
                            }
                            price_range {
                                minimum_price {
                                    regular_price {
                                        currency
                                        value
                                    }
                                    final_price {
                                        currency
                                        value
                                    }
                                }
                            }
                        }
                        ... on BundleProduct {
                            items {
                                options {
                                    uid
                                    id
                                    product {
                                        id
                                        sku
                                        url_key
                                        name
                                        rozmiar_swatch
                                        material_swatch
                                        rodzaj_kamienia_swatch
                                        kolor3_swatch
                                        kolor_emalii_swatch
                                        kolor_kamienia_swatch
                                        cyfry_swatch
                                        alfabet_swatch
                                        znaki_zodiaku_swatch
                                        salable_qty
                                        categories {
                                            name
                                        }
                                        main_category {
                                            name
                                        }
                                    }
                                }
                            }
                            options {
                                ... on CustomizableEngraveOption {
                                    title
                                    uid
                                    value {
                                        code
                                        placement
                                        uid
                                    }
                                }
                            }
                        }
                        upsell_products {
                            name
                            sku
                            salable_qty
                            url_key
                            alfabet_swatch
                            kolor3_swatch
                            cyfry_swatch
                            kolor_emalii_swatch
                            kolor_kamienia_swatch
                            material_swatch
                            rodzaj_kamienia_swatch
                            rozmiar_swatch
                            znaki_zodiaku_swatch
                            image {
                                url
                                label
                            }
                            price_range {
                                minimum_price {
                                    regular_price {
                                        currency
                                        value
                                    }
                                    final_price {
                                        currency
                                        value
                                    }
                                }
                            }
                            ... on BundleProduct {
                                items {
                                    options {
                                        uid
                                        id
                                        product {
                                            id
                                            sku
                                            url_key
                                            name
                                            rozmiar_swatch
                                            material_swatch
                                            rodzaj_kamienia_swatch
                                            kolor3_swatch
                                            kolor_emalii_swatch
                                            kolor_kamienia_swatch
                                            cyfry_swatch
                                            alfabet_swatch
                                            znaki_zodiaku_swatch
                                            main_category {
                                                name
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        price_range {
                            minimum_price {
                                regular_price {
                                    currency
                                    value
                                }
                                final_price {
                                    currency
                                    value
                                }
                            }
                        }
                        image {
                            url
                            label
                        }
                        ... on SimpleProduct {
                            options {
                                ... on CustomizableFieldOption {
                                    option_id
                                    uid
                                    required
                                    title
                                    value {
                                        max_characters
                                        price
                                        price_type
                                    }
                                }
                                ... on CustomizableEngraveOption {
                                    title
                                    uid
                                    value {
                                        code
                                        placement
                                        uid
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

`